import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { motion } from 'framer-motion'

import {
  contentContainer,
  image,
  imageContainer,
  titleStyle,
} from 'modules/trainings/components/content/styles.vanilla.css'
import { ContentViewProps } from 'modules/trainings/components/content/types'
import { PageBlock } from 'modules/trainings/lib/content/PageBlock'

export const PageBlockView = ({ contentItem }: ContentViewProps<PageBlock>) => {
  const [imageLoaded, setImageLoaded] = useState(false)

  return (
    <Box gap="s24" width="full" alignItems="center">
      {contentItem.thumbnail.url ? (
        <Box width="full" className={imageContainer}>
          <motion.img
            src={contentItem.thumbnail.url}
            alt={contentItem.title}
            className={image}
            initial={{ opacity: 0 }}
            animate={{ opacity: imageLoaded ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            onLoad={() => setImageLoaded(true)}
          />
        </Box>
      ) : (
        <Box width="full" paddingTop="s40" />
      )}

      <Box width="full" gap="s24" className={contentContainer}>
        <F0Text content={contentItem.title} variant="body" style={titleStyle} />

        {contentItem.description && (
          <RichTextDisplay content={contentItem.description} format="html" className="text-lg" />
        )}
      </Box>
    </Box>
  )
}
